import actions from './amenities.actions';
import watch from './amenities.operations';
import reducer, { initState } from './amenities.reducers';

export { actions, watch, initState };

export default reducer;
